"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: property/status_legacy.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusLegacy = exports.protobufPackage = void 0;
exports.statusLegacyFromJSON = statusLegacyFromJSON;
exports.statusLegacyToJSON = statusLegacyToJSON;
/* eslint-disable */
exports.protobufPackage = "property";
/**
 * StatusLegacy was previously used to track the current state and availability of property listings.
 *
 * This enum has been deprecated in favor of standard_status and should not be used for new implementations.
 */
var StatusLegacy;
(function (StatusLegacy) {
    /** STATUS_LEGACY_UNSPECIFIED - The status is not specified. */
    StatusLegacy[StatusLegacy["STATUS_LEGACY_UNSPECIFIED"] = 0] = "STATUS_LEGACY_UNSPECIFIED";
    /** STATUS_LEGACY_DELETED - The listing is deleted. */
    StatusLegacy[StatusLegacy["STATUS_LEGACY_DELETED"] = -1] = "STATUS_LEGACY_DELETED";
    /** STATUS_LEGACY_DUPLICATE - The listing is a duplicate. */
    StatusLegacy[StatusLegacy["STATUS_LEGACY_DUPLICATE"] = -10] = "STATUS_LEGACY_DUPLICATE";
    /** STATUS_LEGACY_AVAILABLE - The listing is available. */
    StatusLegacy[StatusLegacy["STATUS_LEGACY_AVAILABLE"] = 1] = "STATUS_LEGACY_AVAILABLE";
    /** STATUS_LEGACY_NOT_AVAILABLE - The listing is not available. */
    StatusLegacy[StatusLegacy["STATUS_LEGACY_NOT_AVAILABLE"] = 2] = "STATUS_LEGACY_NOT_AVAILABLE";
    /** STATUS_LEGACY_NOT_AVAILABLE_SOLD - The listing is not available, sold. */
    StatusLegacy[StatusLegacy["STATUS_LEGACY_NOT_AVAILABLE_SOLD"] = 3] = "STATUS_LEGACY_NOT_AVAILABLE_SOLD";
    /** STATUS_LEGACY_NOT_AVAILABLE_OTHER - The listing is not available, not sold. */
    StatusLegacy[StatusLegacy["STATUS_LEGACY_NOT_AVAILABLE_OTHER"] = 4] = "STATUS_LEGACY_NOT_AVAILABLE_OTHER";
    /** STATUS_LEGACY_NO_GEOMETRY_DATA - The listing cannot be geolocated and has not geolocation data. */
    StatusLegacy[StatusLegacy["STATUS_LEGACY_NO_GEOMETRY_DATA"] = -2] = "STATUS_LEGACY_NO_GEOMETRY_DATA";
})(StatusLegacy || (exports.StatusLegacy = StatusLegacy = {}));
function statusLegacyFromJSON(object) {
    switch (object) {
        case 0:
        case "STATUS_LEGACY_UNSPECIFIED":
            return StatusLegacy.STATUS_LEGACY_UNSPECIFIED;
        case -1:
        case "STATUS_LEGACY_DELETED":
            return StatusLegacy.STATUS_LEGACY_DELETED;
        case -10:
        case "STATUS_LEGACY_DUPLICATE":
            return StatusLegacy.STATUS_LEGACY_DUPLICATE;
        case 1:
        case "STATUS_LEGACY_AVAILABLE":
            return StatusLegacy.STATUS_LEGACY_AVAILABLE;
        case 2:
        case "STATUS_LEGACY_NOT_AVAILABLE":
            return StatusLegacy.STATUS_LEGACY_NOT_AVAILABLE;
        case 3:
        case "STATUS_LEGACY_NOT_AVAILABLE_SOLD":
            return StatusLegacy.STATUS_LEGACY_NOT_AVAILABLE_SOLD;
        case 4:
        case "STATUS_LEGACY_NOT_AVAILABLE_OTHER":
            return StatusLegacy.STATUS_LEGACY_NOT_AVAILABLE_OTHER;
        case -2:
        case "STATUS_LEGACY_NO_GEOMETRY_DATA":
            return StatusLegacy.STATUS_LEGACY_NO_GEOMETRY_DATA;
        default:
            return StatusLegacy.STATUS_LEGACY_DELETED;
    }
}
function statusLegacyToJSON(object) {
    switch (object) {
        case StatusLegacy.STATUS_LEGACY_UNSPECIFIED:
            return "STATUS_LEGACY_UNSPECIFIED";
        case StatusLegacy.STATUS_LEGACY_DELETED:
            return "STATUS_LEGACY_DELETED";
        case StatusLegacy.STATUS_LEGACY_DUPLICATE:
            return "STATUS_LEGACY_DUPLICATE";
        case StatusLegacy.STATUS_LEGACY_AVAILABLE:
            return "STATUS_LEGACY_AVAILABLE";
        case StatusLegacy.STATUS_LEGACY_NOT_AVAILABLE:
            return "STATUS_LEGACY_NOT_AVAILABLE";
        case StatusLegacy.STATUS_LEGACY_NOT_AVAILABLE_SOLD:
            return "STATUS_LEGACY_NOT_AVAILABLE_SOLD";
        case StatusLegacy.STATUS_LEGACY_NOT_AVAILABLE_OTHER:
            return "STATUS_LEGACY_NOT_AVAILABLE_OTHER";
        case StatusLegacy.STATUS_LEGACY_NO_GEOMETRY_DATA:
            return "STATUS_LEGACY_NO_GEOMETRY_DATA";
        default:
            return "STATUS_LEGACY_DELETED";
    }
}
//# sourceMappingURL=status_legacy.js.map